import { render, staticRenderFns } from "./codemirror.vue?vue&type=template&id=3bab6450&"
import script from "./codemirror.vue?vue&type=script&lang=js&"
export * from "./codemirror.vue?vue&type=script&lang=js&"
import style0 from "./codemirror.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports